/* eslint-disable @typescript-eslint/ban-ts-comment */
export const queryStringToObject = <T = Record<string, string>>(url: string): T =>
  [...new URLSearchParams(url.split('?')[1]).entries()].reduce<T>((acc, [key, val]) => {
    // @ts-ignore
    // eslint-disable-next-line no-prototype-builtins
    if (acc.hasOwnProperty(key)) {
      // @ts-ignore
      if (Array.isArray(acc[key])) {
        // @ts-ignore
        acc[key] = [...acc[key], val];
      } else {
        // @ts-ignore
        acc[key] = [acc[key], val];
      }
    } else {
      // @ts-ignore
      acc[key] = val;
    }

    return acc;
  }, {} as T);
